var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationAlertIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 15.6667C10.9119 15.6667 10.8271 15.6315 10.7646 15.569C10.7021 15.5065 10.667 15.4217 10.667 15.3333C10.667 15.2449 10.7021 15.1601 10.7646 15.0976C10.8271 15.0351 10.9119 15 11.0003 15",
    fill: "#C12010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 15.6667C10.9119 15.6667 10.8271 15.6315 10.7646 15.569C10.7021 15.5065 10.667 15.4217 10.667 15.3333C10.667 15.2449 10.7021 15.1601 10.7646 15.0976C10.8271 15.0351 10.9119 15 11.0003 15",
    stroke: "#C12010",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 15.6667C11.0884 15.6667 11.1732 15.6315 11.2357 15.569C11.2982 15.5065 11.3333 15.4217 11.3333 15.3333C11.3333 15.2449 11.2982 15.1601 11.2357 15.0976C11.1732 15.0351 11.0884 15 11 15",
    stroke: "#C12010",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 12.3333V5",
    stroke: "#C12010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11 21C16.5227 21 21 16.5227 21 11C21 5.47733 16.5227 1 11 1C5.47733 1 1 5.47733 1 11C1 16.5227 5.47733 21 11 21Z",
    stroke: "#C12010",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationAlertIcon);
export default __webpack_public_path__ + "static/media/information-alert-icon.1d09864d9fce9529c14838ce9092a3fd.svg";
export { ForwardRef as ReactComponent };